export const defaultPhoneNumberValue = {
  phonePrefix: '+48',
  phone: '',
};
